var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCameraCrossed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 3.33325L10.3333 5.99992V3.66659C10.3333 3.29992 10.0333 2.99992 9.66659 2.99992H5.54659L12.9999 10.4533V3.33325ZM1.17992 0.333252L0.333252 1.17992L2.15325 2.99992H1.66659C1.29992 2.99992 0.999919 3.29992 0.999919 3.66659V10.3333C0.999919 10.6999 1.29992 10.9999 1.66659 10.9999H9.66659C9.80659 10.9999 9.92659 10.9466 10.0266 10.8799L12.1533 12.9999L12.9999 12.1533L1.17992 0.333252Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraCrossed);
export default __webpack_public_path__ + "static/media/videoCameraCrossed.cb40a52ebd538a7d97f2c8640a904164.svg";
export { ForwardRef as ReactComponent };